import { FieldKey, t } from '../i18n';
import { isQuoted } from '../models/common';

import { validateReservedWordsAndPhrases } from './reserved-words';

const validateActivationPhrase = (value: string, isAdmin: boolean, field: FieldKey = 'field-name'): string => {
    const normalized = value.toLowerCase();
    if (normalized === '') {
        return '';
    }

    const error = validateReservedWordsAndPhrases(normalized, isAdmin, field);
    if (error) {
        return error;
    }

    if (/[.,:;!?%^&*()_@]/.test(normalized)) {
        return t('forbidden-symbols', { field: t(field) });
    }
    if (!/[a-zA-Zа-яА-ЯёЁ]/.test(normalized)) {
        return t('no-letter', { field: t(field) });
    }
    if (isQuoted(normalized)) {
        return t('quoted', { field: t(field) });
    }

    return '';
};

export default validateActivationPhrase;
